import React from 'react'
import { observer } from 'mobx-react'
import { ActionFlow } from '~shared/lib/ActionFlow'
import { Alert } from '@instacart/tds'
import catalogStore from '../../Stores/CatalogStore'
import styles from './ManageMenuModal.module.scss'
import { ManageMenuHeader } from './Components/ManageMenuHeader'
import { MenuItemRow } from './Components/MenuItemRow'
import { ManageMenuCloseFooter } from './Components/ManageMenuCloseFooter'

export const ManageMenuListPage: React.FC<{
  path: string
}> = observer(({ path }) => {
  const { isInitialLoading, hasError, isEmpty, items, togglingItemId } = catalogStore
  const isToggling = togglingItemId !== null

  return (
    <ActionFlow.Page
      header={<ManageMenuHeader />}
      path={path}
      footer={<ManageMenuCloseFooter disabled={isToggling} />}
    >
      <div>
        {isInitialLoading && (
          <div className={styles.loadingContainer} data-testid="loading-component">
            <div className="fs-loading-large"></div>
          </div>
        )}

        {hasError && (
          <Alert variant="error">
            <span>There was an error loading the department catalog. Please try again later.</span>
          </Alert>
        )}

        {!isInitialLoading && !hasError && (
          <>
            <Alert layout="horizontal" isDismissible={false} variant="warning">
              <span className={styles.warningMessage}>
                Item availability resets at the beginning of every day.
              </span>
            </Alert>

            {isEmpty ? (
              <div className={styles.emptyState}>
                <span>No catalog items found for this department.</span>
              </div>
            ) : (
              <div className={styles.menuList}>
                {items.map(item => (
                  <MenuItemRow key={item.ItemUid} itemId={item.ItemUid} disabled={isToggling} />
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </ActionFlow.Page>
  )
})
